import React from "react";
import { Reveal, SectionTitle, Highlight } from "@/components/home/homeUi";

const PROSE =
  "reading-prose font-body font-light text-graphite text-[16px] md:text-[17px] leading-[1.9]";

export default function HomeMission() {
  return (
    <section
      id="misszio"
      data-testid="home-mission"
      className="px-6 md:px-10 py-10 md:py-14 bg-tinted border-t border-hairline"
    >
      <SectionTitle testId="home-mission-title" className="mb-7 md:mb-8">
        A <em className="text-gold" style={{ fontStyle: "italic" }}>misszióm</em>
      </SectionTitle>
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 lg:gap-12 items-center">
        <div className="md:col-span-8 lg:col-span-8">
          <Reveal className={PROSE}>
            <p>
              Hiszek abban, hogy az emberi kapcsolódások minőségének változása messze túlmutat az egyénen. Amikor egy ember elkezdi felismerni a saját működését, rálát a kapcsolataiban megjelenő dinamikákra, és új választásokat hoz, azzal nemcsak a saját életében nyithat új lehetőségeket. Mindez hatással lehet a párkapcsolatára, a gyermekeivel való kapcsolatára, a családi rendszerére és a tágabb közösségeire is.
            </p>
          </Reveal>
          <Highlight className="mt-10 md:mt-14" testId="home-mission-highlight">
            Személyes misszióm középpontjában a családi dinamikák és az emberi
            kapcsolódások <span className="text-gold">kiigazítása</span> áll.
          </Highlight>
        </div>
        <Reveal delay={0.15} className="md:col-span-4 md:pt-1">
          <figure className="portrait-frame max-w-[280px] md:max-w-none mx-auto md:mr-[18px]">
            <img
              data-testid="home-mission-image"
              src="/images/forras-kod-kiseres-portrait.jpg"
              alt="Szász-Tóth Enikő"
              className="relative z-10 w-full h-auto block"
              style={{ filter: "saturate(0.96) contrast(1.02)" }}
              loading="lazy"
            />
          </figure>
        </Reveal>
      </div>
      <div className="max-w-5xl mx-auto mt-7 md:mt-9">
        <Reveal className={PROSE}>
          <p>
            Egy olyan új kapcsolódási kultúra kialakulásához szeretnék hozzájárulni, amelyben a kontroll, a hierarchia, a versengés és a ránk rakódott szerepek helyett egyre nagyobb teret kaphatnak az eredendő emberi értékek, a kölcsönös tisztelet, az együttműködés és a tiszta, stabil belső erő. Nem szeretném megmondani, hogyan kellene élned, vagy milyennek kellene lennie a kapcsolataidnak. Abban szeretnélek támogatni, hogy felismerd a saját lehetőségeidet, és a saját belső iránytűd mentén hozhass új döntéseket.
          </p>
        </Reveal>
        <Reveal className="mt-8 md:mt-9 text-center">
          <p
            data-testid="home-mission-closing"
            className="font-serif-display italic text-gold text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45]"
          >
            Mert a változás az egyénben kezdődik, de nem feltétlenül áll meg ott.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
